"use client";

import { useState } from "react";
import { createClient } from "@/lib/supabase/client";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleGoogleSignIn() {
    setLoading(true);
    setError(null);
    const supabase = createClient();
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });
    if (error) {
      setError(error.message);
      setLoading(false);
    }
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-8 bg-paper px-6 py-24">
      <div className="animate-rise text-center">
        <p className="text-[11px] uppercase tracking-[0.18em] text-ink-3">
          испанский на голос
        </p>
        <h1 className="mt-2 font-serif text-5xl text-ink">Sobremesa</h1>
        <p className="mt-3 max-w-sm text-sm leading-6 text-ink-2">
          Задержись за столом — поговорим по-испански.
        </p>
      </div>
      <button
        onClick={handleGoogleSignIn}
        disabled={loading}
        className="flex h-12 items-center justify-center gap-3 rounded-full bg-terracotta px-6 text-base font-medium text-paper transition hover:bg-terracotta-2 disabled:opacity-50"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path
            fill="currentColor"
            d="M21.35 11.1H12v3.2h5.35c-.5 2.4-2.55 3.8-5.35 3.8-3.2 0-5.8-2.6-5.8-5.8s2.6-5.8 5.8-5.8c1.45 0 2.75.55 3.75 1.45l2.4-2.4C16.55 3.8 14.45 3 12 3 7 3 3 7 3 12s4 9 9 9c5.2 0 8.65-3.65 8.65-8.8 0-.4-.05-.7-.3-1.1Z"
          />
        </svg>
        {loading ? "Перенаправляем..." : "Войти через Google"}
      </button>
      {error ? (
        <p className="max-w-sm text-center text-sm text-terracotta-2">
          {error}
        </p>
      ) : null}
    </main>
  );
}
